import React, { useEffect, useState } from 'react';
import styles from './footer.module.scss';
import translations from "../../translations/translations";

import {
  HiOutlineGlobeAlt,
  HiOutlineShieldCheck,
  HiOutlineDocumentText,
  HiOutlineChatBubbleLeftRight,
  HiOutlineAtSymbol
} from 'react-icons/hi2';

import { FaTwitter, FaFacebookF, FaGithub } from 'react-icons/fa';

const Footer = ({ lang = "en" }) => {
  const t = translations[lang].footer;
  const [show, setShow] = useState(true);
  let lastScrollY = 0;

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const isMobile = window.innerWidth < 768;

      //if (!isMobile) 
	  return;

      if (currentScrollY > lastScrollY) {
        setShow(false); // scroll down = hide
      } else {
        setShow(true); // scroll up = show
      }
      lastScrollY = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <footer className={`${styles.footer} ${!show ? styles.hidden : ''}`}>

      <div className={styles.socials}>
        <a href="https://twitter.com" target="_blank" rel="noreferrer" className={styles.socialIcon}>
          <FaTwitter />
        </a>
        <a href="https://facebook.com" target="_blank" rel="noreferrer" className={styles.socialIcon}>
          <FaFacebookF />
        </a>
        <a href="https://github.com" target="_blank" rel="noreferrer" className={styles.socialIcon}>
          <FaGithub />
        </a>
      </div>

      <div className={styles.links}>
        <a href="/rules" className={styles.link}>
          <HiOutlineGlobeAlt className={styles.icon} />
          Rules
        </a>
        <a href="/terms" className={styles.link}>
          <HiOutlineShieldCheck className={styles.icon} />
          Terms
        </a>
        <a href="/privacy" className={styles.link}>
          <HiOutlineDocumentText className={styles.icon} />
          Privacy
        </a>
        <a href="/contact" className={styles.link}>
          <HiOutlineChatBubbleLeftRight className={styles.icon} />
          Contact
        </a>
      </div>

		<div className={styles.copyright}>
		  <HiOutlineAtSymbol className={styles.cIcon} />
		  {new Date().getFullYear()} {t.copyright}
		</div>
    </footer>
  );
};

export default Footer;
